import { format, parseISO, isValid } from "date-fns";

export const AU_STATES = ["NSW", "VIC", "QLD", "WA", "SA", "TAS", "ACT", "NT"];

const aud = new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" });
export const money = (v) => aud.format(Number(v) || 0);

export const fmtDate = (iso) => {
  if (!iso) return "";
  const d = parseISO(iso);
  return isValid(d) ? format(d, "dd/MM/yyyy") : iso;
};

export function isValidABN(abn) {
  const digits = (abn || "").replace(/\s/g, "");
  if (!/^\d{11}$/.test(digits)) return false;
  const w = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
  const sum = digits.split("").reduce((s, d, i) => s + (Number(d) - (i === 0 ? 1 : 0)) * w[i], 0);
  return sum % 89 === 0;
}

export function lineTotal(i) {
  const q = Number(i.quantity) || 0;
  const p = Number(i.unit_price) || 0;
  if (i.pricing_type === "length") return q * (Number(i.length) || 0) * p;
  if (i.pricing_type === "area") return q * (Number(i.length) || 0) * (Number(i.width) || 0) * p;
  return q * p;
}

export const uid = () => Math.random().toString(36).slice(2, 10);

export const customerName = (c) => (c ? c.company_name || c.contact_name : "—");
